import classNames from 'classnames';
import { forwardRef } from 'react';
import './growing-textarea.scss';

type GrowingTextareaProps = {
  containerClassName?: string;
} & JSX.IntrinsicElements['textarea'];

export const GrowingTextarea = forwardRef<HTMLTextAreaElement, GrowingTextareaProps>(
  ({ containerClassName, value, ...props }: GrowingTextareaProps, ref) => {
    return (
      <span className={classNames('growing-textarea-container', containerClassName)} data-value={value}>
        <textarea
          ref={ref}
          rows={1}
          value={value}
          // Prevent treating this field as password autofill
          autoComplete='off'
          data-1p-ignore
          data-lpignore='true'
          data-form-type='other'
          {...props}
        />
      </span>
    );
  },
);
